import React, { useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import ActionTable from "../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";
import { mergeParams } from "../../helpers/helpers";

export default function Lista({ history, location }) {
  const [dados, setDados] = useState(
    mergeParams({ nome: "", exibirInativos: false }, location)
  );
  const [produtos, setProdutos] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    carregarProdutos();
  }, []);

  const carregarProdutos = (filtrosEnviar = dados) => {
    setDados(filtrosEnviar);
    setCarregando(true);
    console.log("filtrosEnviar", filtrosEnviar);
    api.get("produtos/listar", filtrosEnviar).then((res) => {
      setProdutos(res);
      setCarregando(false);
    });
  };

  const filtros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 10,
        value: dados.nome,
      },
      exibirInativos: {
        type: "check",
        label: "Exibir inativos",
        space: 2,
        value: dados.exibirInativos,
      },
    },

    submit: {
      label: "Buscar",
      action: carregarProdutos,
    },

    urlParams: true,
    history,
    location,
  };

  const tRegistros = {
    title: "Categorias",
    newItemAction: () => history.push("/app/produto/item/0"),
    onLineClick: (id) => history.push(`/app/produto/item/${id.id}`),
    columns: [
      {
        label: "Nome",
        name: "nome",
      },
    ],
    array: produtos,
  };

  return (
    <div>
      <Form formData={filtros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
